export default __webpack_public_path__ + "static/media/chatIcon.0d88ca51.svg";